import { render, staticRenderFns } from "./connectUs.vue?vue&type=template&id=5c349aa2&scoped=true"
import script from "./connectUs.vue?vue&type=script&lang=js"
export * from "./connectUs.vue?vue&type=script&lang=js"
import style0 from "./connectUs.vue?vue&type=style&index=0&id=5c349aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c349aa2",
  null
  
)

export default component.exports